import toMap from '~/misc/toMap';

export default toMap([
  'LOADS_SEARCH',
  'LOADS_SORT',
  'LOADS_LIST_LIMIT_CHANGED',
  'LOADS_MORE',
  'LOADS_UPDATE',
  'LOADS_BOOKING',
  'LOADS_BID',
  'LOADS_CRITERIA_COMPLETED',
  'LOADS_REFRESHED',
  'SEARCH_CRITERIA',
  'HIDE_THE_LOADS',
  'HIDE_THE_COMPANY',
  'LOADS_COLLECTION_THE_COMPANY',
  'LOADS_NO_COLLECTION_COMPANY',
  'LOADS_CHECKED',
  'LOADS_CHECKED_ALL',
  'CLEAR_CHECKED',
  'UPDATE_CHECKED',
  'LOADS_INDICATOR_DATA',
  'LOADS_CAPACITY_RATIO'
]);



// WEBPACK FOOTER //
// ./src/modules/loadsSearch/types.js